var map = {
	"./404.gif": 523072,
	"./aboutUs/aboutUsProductsAndServices/agriculturalProductsAndEquipment.png": 596570,
	"./aboutUs/aboutUsProductsAndServices/agriculturalProductsAndEquipment.webp": 235573,
	"./aboutUs/aboutUsProductsAndServices/agriculturalServices.png": 837077,
	"./aboutUs/aboutUsProductsAndServices/agriculturalServices.webp": 347352,
	"./aboutUs/aboutUsProductsAndServices/financing.png": 1072,
	"./aboutUs/aboutUsProductsAndServices/financing.webp": 485643,
	"./aboutUs/aboutUsProductsAndServices/marketAnalyticsAndNews.png": 939220,
	"./aboutUs/aboutUsProductsAndServices/marketAnalyticsAndNews.webp": 623850,
	"./aboutUs/aboutUsProductsAndServices/saleOfHarvest.png": 597474,
	"./aboutUs/aboutUsProductsAndServices/saleOfHarvest.webp": 529773,
	"./aboutUs/ad/advertisingBannerBg.png": 315164,
	"./aboutUs/ad/advertisingBannerBg.webp": 588163,
	"./aboutUs/ad/advertisingBannerBgMobile.png": 943643,
	"./aboutUs/ad/advertisingBannerBgMobile.webp": 193124,
	"./aboutUs/ad/advertisingBannerBgTablet.png": 558838,
	"./aboutUs/ad/advertisingBannerBgTablet.webp": 507549,
	"./aboutUs/ad/cartForMoney.png": 463630,
	"./aboutUs/ad/cartForMoney.webp": 202977,
	"./aboutUs/decor.png": 403825,
	"./aboutUs/media/agroinvestor.png": 441039,
	"./aboutUs/media/agroinvestor.webp": 988837,
	"./aboutUs/media/glavagronom.png": 15185,
	"./aboutUs/media/glavagronom.webp": 267929,
	"./aboutUs/media/graphics.png": 184291,
	"./aboutUs/media/graphics.webp": 642089,
	"./aboutUs/media/rbc.png": 461409,
	"./aboutUs/media/rbc.webp": 193438,
	"./aboutUs/top-banner.png": 224091,
	"./aboutUs/top-banner.webp": 714253,
	"./aboutUs/top-bannerMobile.png": 65036,
	"./aboutUs/top-bannerMobile.webp": 454486,
	"./aboutUs/top-bannerTablet.png": 843038,
	"./aboutUs/top-bannerTablet.webp": 490676,
	"./agriculturalProducts/moreCategories.png": 55576,
	"./agriculturalProducts/moreCategories.webp": 778046,
	"./agriculturalProducts/productsBanner.png": 617088,
	"./agriculturalProducts/productsBanner.webp": 147026,
	"./agriculturalProducts/productsListBanner-common.png": 525019,
	"./agriculturalProducts/productsListBanner-common.webp": 19333,
	"./agriculturalProducts/productsListBanner-spares.png": 725539,
	"./agriculturalProducts/productsListBanner-spares.webp": 993352,
	"./agriculturalProducts/productsListBannerMobile-common.png": 795132,
	"./agriculturalProducts/productsListBannerMobile-common.webp": 127343,
	"./agriculturalProducts/productsListBannerMobile-spares.png": 863583,
	"./agriculturalProducts/productsListBannerMobile-spares.webp": 595999,
	"./agriculturalProducts/wideMoreCategories.png": 454764,
	"./agriculturalProducts/wideMoreCategories.webp": 380134,
	"./agroservices/agroconsulting/expert2.png": 608478,
	"./agroservices/agronoutFarmlandCropValuation.png": 161613,
	"./agroservices/agronoutFarmlandCropValuation.webp": 453573,
	"./agroservices/agronoutFarmlandCropValuationMobile.png": 281129,
	"./agroservices/agronoutFarmlandCropValuationMobile.webp": 67051,
	"./agroservices/agronoutFarmlandCropValuationTablet.png": 213726,
	"./agroservices/agronoutFarmlandCropValuationTablet.webp": 972266,
	"./agroservices/agronoutHeader.png": 592398,
	"./agroservices/agronoutHeader.webp": 43834,
	"./agroservices/agronoutHeaderMobile.png": 276890,
	"./agroservices/agronoutHeaderMobile.webp": 19546,
	"./agroservices/agronoutHeaderTablet.png": 683076,
	"./agroservices/agronoutHeaderTablet.webp": 200040,
	"./agroservices/agronoutLogo.png": 406202,
	"./agroservices/agronoutLogo.webp": 397,
	"./agroservices/agronoutQueryForm.png": 852884,
	"./agroservices/agronoutQueryForm.webp": 169990,
	"./agroservices/agronoutWhatGet.png": 247429,
	"./agroservices/agronoutWhatGet.webp": 991376,
	"./agroservices/agroservicesEfisZsn.png": 718382,
	"./agroservices/agroservicesEfisZsn.webp": 293875,
	"./agroservices/agroservicesYouDo.png": 904892,
	"./agroservices/agroservicesYouDo.webp": 670740,
	"./agroservices/calcLogo.svg": 301206,
	"./agroservices/efisZsnLearn.png": 794250,
	"./agroservices/efisZsnLearn.webp": 858888,
	"./agroservices/efisZsnSolution.png": 402199,
	"./agroservices/efisZsnSolution.webp": 181635,
	"./agroservices/exactFarmingHeader.png": 348890,
	"./agroservices/exactFarmingHeader.webp": 642961,
	"./agroservices/exactFarmingLogo.png": 16341,
	"./agroservices/exactFarmingLogo.webp": 275086,
	"./agroservices/exactFarmingPhone.png": 800525,
	"./agroservices/exactFarmingPhone.webp": 640516,
	"./agroservices/fertilizers.png": 660422,
	"./agroservices/fertilizers.webp": 361107,
	"./agroservices/fertilizersMobile.png": 826263,
	"./agroservices/fertilizersMobile.webp": 515264,
	"./agroservices/fertilizersTablet.png": 648027,
	"./agroservices/fertilizersTablet.webp": 346037,
	"./agroservices/fgis-laptop.png": 530410,
	"./agroservices/fgis-laptop.webp": 138979,
	"./agroservices/fgis-wheat.png": 743461,
	"./agroservices/fgis-wheat.webp": 882462,
	"./agroservices/fieldEvaluationReport/bannerDesktopLeft.png": 817891,
	"./agroservices/fieldEvaluationReport/bannerDesktopLeft.webp": 283685,
	"./agroservices/fieldEvaluationReport/bannerDesktopRight.png": 834905,
	"./agroservices/fieldEvaluationReport/bannerDesktopRight.webp": 516632,
	"./agroservices/fieldEvaluationReport/bannerMobile.png": 530512,
	"./agroservices/fieldEvaluationReport/bannerMobile.webp": 741420,
	"./agroservices/fieldEvaluationReport/bannerTabletLeft.png": 633404,
	"./agroservices/fieldEvaluationReport/bannerTabletLeft.webp": 999110,
	"./agroservices/fieldEvaluationReport/bannerTabletRight.png": 600734,
	"./agroservices/fieldEvaluationReport/bannerTabletRight.webp": 470877,
	"./agroservices/fieldEvaluationReport/calendar.png": 129730,
	"./agroservices/fieldEvaluationReport/calendar.webp": 727296,
	"./agroservices/fieldEvaluationReport/fence.png": 921041,
	"./agroservices/fieldEvaluationReport/fence.webp": 204976,
	"./agroservices/fieldEvaluationReport/header.jpg": 292632,
	"./agroservices/fieldEvaluationReport/header.webp": 138957,
	"./agroservices/fieldEvaluationReport/polygonalMap.png": 160264,
	"./agroservices/fieldEvaluationReport/polygonalMap.webp": 709231,
	"./agroservices/fieldEvaluationReport/realisticMap.png": 542894,
	"./agroservices/fieldEvaluationReport/realisticMap.webp": 956397,
	"./agroservices/fieldEvaluationReport/satellitePhotography.png": 384000,
	"./agroservices/fieldEvaluationReport/satellitePhotography.webp": 204322,
	"./agroservices/mobileAgronoutQueryForm.png": 923377,
	"./agroservices/mobileAgronoutQueryForm.webp": 561598,
	"./agroservices/poleDiffScreen1.png": 654744,
	"./agroservices/poleDiffScreen1.webp": 597541,
	"./agroservices/poleDiffScreen2.png": 697927,
	"./agroservices/poleDiffScreen2.webp": 554480,
	"./agroservices/poleDiffScreen3.png": 37155,
	"./agroservices/poleDiffScreen3.webp": 226195,
	"./agroservices/poleExpertScreen1.png": 232058,
	"./agroservices/poleExpertScreen1.webp": 998905,
	"./agroservices/poleExpertScreen2.png": 892265,
	"./agroservices/poleExpertScreen2.webp": 728560,
	"./agroservices/poleExpertScreen3.png": 813365,
	"./agroservices/poleExpertScreen3.webp": 572422,
	"./agroservices/poleExpertScreen4.png": 435131,
	"./agroservices/poleExpertScreen4.webp": 404903,
	"./agroservices/polePlusScouting.png": 91592,
	"./agroservices/polePlusScouting.webp": 664572,
	"./agroservices/polePlusScreen1.png": 852969,
	"./agroservices/polePlusScreen1.webp": 386437,
	"./agroservices/polePlusScreen2.png": 363472,
	"./agroservices/polePlusScreen2.webp": 199914,
	"./agroservices/polePlusScreen3.png": 238747,
	"./agroservices/polePlusScreen3.webp": 463932,
	"./agroservices/polePlusScreen4.png": 31806,
	"./agroservices/polePlusScreen4.webp": 21837,
	"./agroservices/polePlusWeatherForecast.png": 881719,
	"./agroservices/polePlusWeatherForecast.webp": 252619,
	"./agroservices/poleScoutingScreen1.png": 416643,
	"./agroservices/poleScoutingScreen1.webp": 494897,
	"./agroservices/poleScoutingScreen2.png": 107375,
	"./agroservices/poleScoutingScreen2.webp": 744421,
	"./agroservices/poleScoutingScreen3.png": 898920,
	"./agroservices/poleScoutingScreen3.webp": 200294,
	"./agroservices/poleScoutingScreen4.png": 515589,
	"./agroservices/poleScoutingScreen4.webp": 743315,
	"./agroservices/seedingRateCalc/seeding-rate-calc-why.png": 971399,
	"./agroservices/seedingRateCalc/seeding-rate-calc-why.webp": 662234,
	"./agroservices/tabletAgronoutQueryForm.png": 10540,
	"./agroservices/tabletAgronoutQueryForm.webp": 503903,
	"./agroservices/tomato.png": 354755,
	"./agroservices/tomato.webp": 661869,
	"./agroservices/tomatoMobile.png": 366203,
	"./agroservices/tomatoMobile.webp": 868807,
	"./agroservices/tomatoTablet.png": 636705,
	"./agroservices/tomatoTablet.webp": 115909,
	"./agroservices/youDoBanner.png": 163321,
	"./agroservices/youDoBanner.webp": 683840,
	"./agroservices/youDoBannerMobile.png": 68802,
	"./agroservices/youDoBannerMobile.webp": 574063,
	"./agroservices/youDoBannerTablet.png": 383975,
	"./agroservices/youDoBannerTablet.webp": 690887,
	"./agroservices/youDoPayments.png": 332853,
	"./agroservices/youDoPayments.webp": 30541,
	"./agroservices/youDoSolution.png": 576980,
	"./agroservices/youDoSolution.webp": 734671,
	"./agroservices/youDoWork.png": 883877,
	"./agroservices/youDoWork.webp": 426413,
	"./auctionForm/placemark.svg": 698196,
	"./banner/harvest-sale-banner-image.svg": 490037,
	"./banner/profile-initial-page-header.svg": 587422,
	"./banner/profile-initial-page-headerMobile.svg": 397227,
	"./banner/profile-initial-page-headerTablet.svg": 447580,
	"./bargainLine.png": 271681,
	"./charter.png": 558775,
	"./contract/template.png": 563715,
	"./contract/template.webp": 544439,
	"./errors/404.png": 905687,
	"./fieldEvaluationReportDialog/preview1.png": 813941,
	"./fieldEvaluationReportDialog/preview1.webp": 990882,
	"./fieldEvaluationReportDialog/preview2.png": 405069,
	"./fieldEvaluationReportDialog/preview2.webp": 788845,
	"./fieldEvaluationReportDialog/preview3.png": 461187,
	"./fieldEvaluationReportDialog/preview3.webp": 13918,
	"./financing/abstractBackground1.png": 582830,
	"./financing/abstractBackground1.webp": 756716,
	"./financing/abstractBackground2.png": 303427,
	"./financing/abstractBackground2.webp": 720891,
	"./financing/abstractBackground3.png": 322463,
	"./financing/abstractBackground3.webp": 590912,
	"./financing/agentBanner.png": 644573,
	"./financing/agentBanner.webp": 131147,
	"./financing/coinWithWheat.png": 411745,
	"./financing/coinWithWheat.webp": 966463,
	"./financing/coins.png": 172924,
	"./financing/coins.webp": 712997,
	"./financing/farmersChoice.svg": 267941,
	"./financing/farmersChoiceMobile.svg": 922238,
	"./financing/inRegistry.png": 441559,
	"./financing/inRegistry.webp": 55804,
	"./financing/mobileAbstractBackground1.png": 632085,
	"./financing/mobileAbstractBackground1.webp": 165089,
	"./financing/mobileAbstractBackground2.png": 974117,
	"./financing/mobileAbstractBackground2.webp": 680716,
	"./financing/mobileAbstractBackground3.png": 684613,
	"./financing/mobileAbstractBackground3.webp": 570331,
	"./financing/profileMFOBanner.png": 349504,
	"./financing/profileMFOBanner.webp": 395614,
	"./financing/promoBanner.png": 900201,
	"./financing/promoBanner.webp": 423085,
	"./financing/promoBannerMobile.png": 102394,
	"./financing/promoBannerMobile.webp": 189577,
	"./financing/promoBannerTablet.png": 255825,
	"./financing/promoBannerTablet.webp": 114147,
	"./financing/tabletAbstractBackground1.png": 851926,
	"./financing/tabletAbstractBackground1.webp": 644541,
	"./financing/tabletAbstractBackground3.png": 918382,
	"./financing/tabletAbstractBackground3.webp": 897417,
	"./financing/topBanner.png": 604461,
	"./financing/topBanner.webp": 550927,
	"./financing/topBannerMobile.png": 380612,
	"./financing/topBannerMobile.webp": 492016,
	"./financing/topBannerTablet.png": 371522,
	"./financing/topBannerTablet.webp": 164276,
	"./financingOffer/Interlesing.png": 251097,
	"./financingOffer/abstractBackground1.png": 786404,
	"./financingOffer/abstractBackground1.webp": 62725,
	"./financingOffer/abstractBackground2.png": 817961,
	"./financingOffer/abstractBackground2.webp": 702445,
	"./financingOffer/abstractBackground3.png": 69941,
	"./financingOffer/abstractBackground3.webp": 224222,
	"./financingOffer/abstractBackground4.png": 21686,
	"./financingOffer/abstractBackground4.webp": 395774,
	"./financingOffer/abstractBackgroundMobile1.png": 742820,
	"./financingOffer/abstractBackgroundMobile1.webp": 724869,
	"./financingOffer/advancePaymentOnFutureHarvest.png": 290446,
	"./financingOffer/advancePaymentOnFutureHarvest.webp": 723934,
	"./financingOffer/advancePaymentOnFutureHarvest/benefits.png": 333216,
	"./financingOffer/advancePaymentOnFutureHarvest/benefits.webp": 745824,
	"./financingOffer/advancePaymentOnFutureHarvest/discountBannerBackground.png": 58386,
	"./financingOffer/advancePaymentOnFutureHarvest/discountBannerBackground.webp": 305636,
	"./financingOffer/advancePaymentOnFutureHarvest/formBackgroundDesktop.png": 173550,
	"./financingOffer/advancePaymentOnFutureHarvest/formBackgroundDesktop.webp": 795416,
	"./financingOffer/advancePaymentOnFutureHarvest/formBackgroundTablet.png": 344586,
	"./financingOffer/advancePaymentOnFutureHarvest/formBackgroundTablet.webp": 744771,
	"./financingOffer/advancePaymentOnFutureHarvest/harvester.png": 968767,
	"./financingOffer/advancePaymentOnFutureHarvest/harvester.webp": 221037,
	"./financingOffer/advancePaymentOnFutureHarvest/mainBackground.svg": 967929,
	"./financingOffer/advancePaymentOnFutureHarvest/suitcase.png": 59122,
	"./financingOffer/advancePaymentOnFutureHarvest/suitcase.webp": 770615,
	"./financingOffer/advancePaymentOnFutureHarvestBenefits.png": 8066,
	"./financingOffer/advancePaymentOnFutureHarvestBenefits.webp": 367991,
	"./financingOffer/advancePaymentOnFutureHarvestBenefitsMobile.png": 106346,
	"./financingOffer/advancePaymentOnFutureHarvestBenefitsMobile.webp": 191357,
	"./financingOffer/advancePaymentOnFutureHarvestBenefitsTablet.png": 561313,
	"./financingOffer/advancePaymentOnFutureHarvestBenefitsTablet.webp": 245988,
	"./financingOffer/agent/benefits/bagOfMoney.png": 93036,
	"./financingOffer/agent/benefits/bagWithMan.png": 388223,
	"./financingOffer/agent/benefits/cards.png": 263314,
	"./financingOffer/agent/benefits/jackdawCalendar.png": 994568,
	"./financingOffer/agent/benefits/jackdawGear.png": 825148,
	"./financingOffer/agent/benefits/manWithJackdaw.png": 287985,
	"./financingOffer/agent/benefits/ruble.png": 819423,
	"./financingOffer/agent/bet-insurance.png": 229374,
	"./financingOffer/agent/bet-insurance.webp": 389900,
	"./financingOffer/agent/calculator.svg": 187211,
	"./financingOffer/agent/connections/email.png": 586532,
	"./financingOffer/agent/connections/phone.png": 676197,
	"./financingOffer/agent/form.png": 862733,
	"./financingOffer/agent/form.webp": 164622,
	"./financingOffer/agent/form_mobile.png": 473176,
	"./financingOffer/agent/form_mobile.webp": 254350,
	"./financingOffer/agent/form_tablet.png": 236656,
	"./financingOffer/agent/form_tablet.webp": 915124,
	"./financingOffer/agent/header.png": 498564,
	"./financingOffer/agent/header.webp": 518809,
	"./financingOffer/agent/howworks/arrow-down-grey.png": 530572,
	"./financingOffer/agent/howworks/arrow-down-grey.svg": 48583,
	"./financingOffer/agent/howworks/arrow-right-grey.png": 206817,
	"./financingOffer/agent/howworks/arrow-right-grey.svg": 373044,
	"./financingOffer/agent/howworks/coin.png": 636102,
	"./financingOffer/agent/howworks/handshake.png": 186612,
	"./financingOffer/agent/howworks/operator.png": 92348,
	"./financingOffer/agent/intresting/bank.png": 381741,
	"./financingOffer/agent/intresting/coinRuble.png": 648862,
	"./financingOffer/agent/intresting/darts.png": 50492,
	"./financingOffer/agent/intresting/jackdawCalendarGold.png": 764332,
	"./financingOffer/agent/intresting/jackdawDocuments.png": 534313,
	"./financingOffer/agent/intresting/wheatCoin.png": 957344,
	"./financingOffer/agent/logo.png": 457399,
	"./financingOffer/agent/logo.svg": 168810,
	"./financingOffer/agent/modal/bag_money.png": 952526,
	"./financingOffer/agent/modal/bag_money.webp": 120316,
	"./financingOffer/agent/modal/book.png": 443550,
	"./financingOffer/agent/modal/book.webp": 586910,
	"./financingOffer/agent/modal/cart.png": 624133,
	"./financingOffer/agent/modal/cart.webp": 227140,
	"./financingOffer/agent/modal/coin.png": 829089,
	"./financingOffer/agent/modal/coin.webp": 183740,
	"./financingOffer/agent/modal/coin_wheat.png": 977744,
	"./financingOffer/agent/modal/coin_wheat.webp": 747679,
	"./financingOffer/agent/modal/hand_with_desk.png": 355005,
	"./financingOffer/agent/modal/hand_with_desk.webp": 370262,
	"./financingOffer/agent/modal/money.png": 372203,
	"./financingOffer/agent/modal/money.webp": 579384,
	"./financingOffer/agent/pole-finance-and-alfabank.png": 889696,
	"./financingOffer/agent/pole-finance-and-alfabank.webp": 824046,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasing.png": 869144,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasing.webp": 503525,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasingBenefits.png": 755215,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasingBenefits.webp": 568748,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasingBenefitsMobile.png": 192652,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasingBenefitsMobile.webp": 490923,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasingBenefitsTablet.png": 470595,
	"./financingOffer/agriculturalMachinesAndEquipmentLeasingBenefitsTablet.webp": 866207,
	"./financingOffer/agroconsulting.png": 223029,
	"./financingOffer/agroconsulting.webp": 588499,
	"./financingOffer/agroconsultingBenefits.png": 230874,
	"./financingOffer/agroconsultingBenefits.webp": 780599,
	"./financingOffer/agroconsultingBenefitsMobile.png": 816385,
	"./financingOffer/agroconsultingBenefitsMobile.webp": 453040,
	"./financingOffer/agroconsultingBenefitsTablet.png": 154173,
	"./financingOffer/agroconsultingBenefitsTablet.webp": 62516,
	"./financingOffer/alfaLeasing.png": 782402,
	"./financingOffer/alfaLeasing.webp": 39426,
	"./financingOffer/alfaLombard.png": 567221,
	"./financingOffer/alfaLombard.webp": 720680,
	"./financingOffer/alfaLombardMobile.png": 242862,
	"./financingOffer/alfaLombardMobile.webp": 809363,
	"./financingOffer/alfaLombardTablet.png": 786688,
	"./financingOffer/alfaLombardTablet.webp": 250334,
	"./financingOffer/bannerFinancingOffer.png": 563713,
	"./financingOffer/bannerFinancingOffer.webp": 782733,
	"./financingOffer/carMarksOfferBanner.png": 561486,
	"./financingOffer/carMarksOfferBanner.webp": 44474,
	"./financingOffer/carMarksOfferBannerMobile.png": 210418,
	"./financingOffer/carMarksOfferBannerMobile.webp": 614233,
	"./financingOffer/centerInvestLoan.png": 823482,
	"./financingOffer/centerInvestLoan.webp": 808778,
	"./financingOffer/centerInvestLoanBenefits.png": 424080,
	"./financingOffer/centerInvestLoanBenefits.webp": 11434,
	"./financingOffer/centerInvestLoanBenefitsMobile.png": 268762,
	"./financingOffer/centerInvestLoanBenefitsMobile.webp": 84397,
	"./financingOffer/centerInvestLoanBenefitsTablet.png": 261978,
	"./financingOffer/centerInvestLoanBenefitsTablet.webp": 687718,
	"./financingOffer/centerInvestLoanMobile.png": 164455,
	"./financingOffer/centerInvestLoanMobile.webp": 849375,
	"./financingOffer/centerInvestLoanTablet.png": 308653,
	"./financingOffer/centerInvestLoanTablet.webp": 944746,
	"./financingOffer/express.png": 738481,
	"./financingOffer/express.webp": 874065,
	"./financingOffer/expressBenefits.png": 987301,
	"./financingOffer/expressBenefits.webp": 230777,
	"./financingOffer/expressBenefitsMobile.png": 712658,
	"./financingOffer/expressBenefitsMobile.webp": 574614,
	"./financingOffer/expressBenefitsTablet.png": 269791,
	"./financingOffer/expressBenefitsTablet.webp": 278345,
	"./financingOffer/expressCreditAlfaBank.png": 326547,
	"./financingOffer/expressCreditAlfaBank.webp": 509634,
	"./financingOffer/expressCreditAlfaBankMobile.png": 513676,
	"./financingOffer/expressCreditAlfaBankMobile.webp": 497626,
	"./financingOffer/expressCreditAlfaBankTablet.png": 135105,
	"./financingOffer/expressCreditAlfaBankTablet.webp": 281151,
	"./financingOffer/fleetFinanceLeasing.png": 630326,
	"./financingOffer/fleetFinanceLeasing.webp": 756872,
	"./financingOffer/fleetFinanceLeasingMobile.png": 705659,
	"./financingOffer/fleetFinanceLeasingMobile.webp": 598429,
	"./financingOffer/fleetFinanceLeasingTablet.png": 804064,
	"./financingOffer/fleetFinanceLeasingTablet.webp": 144666,
	"./financingOffer/interlesing.webp": 128486,
	"./financingOffer/investment.png": 569149,
	"./financingOffer/investment.webp": 791189,
	"./financingOffer/investmentBenefits.png": 551584,
	"./financingOffer/investmentBenefits.webp": 961979,
	"./financingOffer/investmentBenefitsMobile.png": 68828,
	"./financingOffer/investmentBenefitsMobile.webp": 105898,
	"./financingOffer/investmentBenefitsTablet.png": 70039,
	"./financingOffer/investmentBenefitsTablet.webp": 119221,
	"./financingOffer/lombardLoanAlfaBank.png": 649375,
	"./financingOffer/lombardLoanAlfaBank.webp": 384022,
	"./financingOffer/lombardLoanAlfaBankTablet.png": 895746,
	"./financingOffer/lombardLoanAlfaBankTablet.webp": 79825,
	"./financingOffer/mfo.png": 481458,
	"./financingOffer/mfo/benefits/earlyRepayment.png": 242259,
	"./financingOffer/mfo/benefits/probabilityOfApproval.png": 333998,
	"./financingOffer/mfo/benefits/replaymentAtEndOfTerm.png": 561149,
	"./financingOffer/mfo/benefits/simpleProcedure.png": 444768,
	"./financingOffer/mfo/benefits/suitedFor.png": 797145,
	"./financingOffer/mfo/benefits/transferToAnyBank.png": 675693,
	"./financingOffer/mfo/header.png": 990792,
	"./financingOffer/mfo/header.webp": 942433,
	"./financingOffer/mfo/logo.svg": 169276,
	"./financingOffer/mfo/quoteSign.svg": 137596,
	"./financingOffer/mfo/reviewLogo.png": 590983,
	"./financingOffer/mfo/reviewLogo.webp": 276817,
	"./financingOffer/mfo/suitcase.png": 727702,
	"./financingOffer/mfo/suitcase.webp": 43234,
	"./financingOffer/mobileAbstractBackground3.png": 137081,
	"./financingOffer/mobileAbstractBackground3.webp": 451261,
	"./financingOffer/mobileAbstractBackground4.png": 959773,
	"./financingOffer/mobileAbstractBackground4.webp": 659288,
	"./financingOffer/mobileAbstractBackground5.png": 323425,
	"./financingOffer/mobileAbstractBackground5.webp": 313615,
	"./financingOffer/mobileHeader.png": 224298,
	"./financingOffer/mobileHeader.webp": 720332,
	"./financingOffer/poleFinanceLogo.svg": 971089,
	"./financingOffer/radial.svg": 909006,
	"./financingOffer/revolving.png": 463814,
	"./financingOffer/revolving.webp": 718419,
	"./financingOffer/revolvingBenefits.png": 782924,
	"./financingOffer/revolvingBenefits.webp": 151717,
	"./financingOffer/revolvingBenefitsMobile.png": 746335,
	"./financingOffer/revolvingBenefitsMobile.webp": 98755,
	"./financingOffer/revolvingBenefitsTablet.png": 182090,
	"./financingOffer/revolvingBenefitsTablet.webp": 982331,
	"./financingOffer/sberLeasing.png": 736873,
	"./financingOffer/sberLeasing.webp": 593224,
	"./financingOffer/sberRassrochka.png": 892353,
	"./financingOffer/sberRassrochka.webp": 149494,
	"./financingOffer/tabletAbstractBackground2.png": 589437,
	"./financingOffer/tabletAbstractBackground2.webp": 164750,
	"./financingOffer/tinkoffLanding.png": 636280,
	"./financingOffer/tinkoffLanding.webp": 219837,
	"./financingOffer/tinkoffLandingMobile.png": 867779,
	"./financingOffer/tinkoffLandingMobile.webp": 330258,
	"./financingOffer/tinkoffLandingTablet.png": 523688,
	"./financingOffer/tinkoffLandingTablet.webp": 116305,
	"./financingOffer/transportAndSpecialEquipmentLeasing.png": 890449,
	"./financingOffer/transportAndSpecialEquipmentLeasing.webp": 36558,
	"./financingOffer/trucksLeasingBanner.png": 759760,
	"./financingOffer/trucksLeasingBanner.webp": 706439,
	"./financingOffer/trucksLeasingBannerMobile.png": 159407,
	"./financingOffer/trucksLeasingBannerMobile.webp": 73079,
	"./harvestSale/advertisingBanner.png": 220480,
	"./harvestSale/advertisingBanner.webp": 416479,
	"./harvestSale/advertisingBannerMobile.png": 514650,
	"./harvestSale/advertisingBannerMobile.webp": 168782,
	"./harvestSale/advertisingBannerTablet.png": 556948,
	"./harvestSale/advertisingBannerTablet.webp": 443315,
	"./harvestSale/lotBanner.png": 741776,
	"./harvestSale/lotBannerCompact.svg": 233042,
	"./harvestSale/lotBannerDesktop.svg": 578853,
	"./harvestSale/lotBannerMobile.svg": 544468,
	"./harvestSale/topBanner.png": 511135,
	"./harvestSale/topBanner.webp": 185132,
	"./harvestSale/topBannerMobile.png": 987952,
	"./harvestSale/topBannerMobile.webp": 957936,
	"./harvestSale/topBannerTablet.png": 841227,
	"./harvestSale/topBannerTablet.webp": 424874,
	"./illustrations/pep-bank.svg": 820765,
	"./illustrations/pep-counterOrder.svg": 264354,
	"./illustrations/pep-smartphone.svg": 809172,
	"./illustrations/pep-validity.svg": 481685,
	"./illustrations/ukep-bank.svg": 721036,
	"./illustrations/ukep-counterOrder.svg": 116316,
	"./illustrations/ukep-smartphone.svg": 816337,
	"./illustrations/ukep-validity.svg": 182572,
	"./index/about/funding-banner.png": 313836,
	"./index/about/funding-banner.webp": 634771,
	"./index/advantages-grain.png": 944324,
	"./index/advantages-machine.png": 490599,
	"./index/advantages-money.png": 51581,
	"./index/agroServices/agrocalculator.png": 937190,
	"./index/agroServices/agrocalculator.webp": 193160,
	"./index/agroServices/consulting.png": 165461,
	"./index/agroServices/consulting.webp": 814585,
	"./index/agroServices/ef_diff.png": 176064,
	"./index/agroServices/ef_diff.webp": 491847,
	"./index/agroServices/ef_expert.png": 8447,
	"./index/agroServices/ef_expert.webp": 101915,
	"./index/agroServices/ef_plus.png": 890392,
	"./index/agroServices/ef_plus.webp": 80903,
	"./index/agroServices/ef_scout.png": 62916,
	"./index/agroServices/ef_scout.webp": 734109,
	"./index/agroServices/efisZsn.png": 719149,
	"./index/agroServices/efisZsn.webp": 16123,
	"./index/agroServices/faq.png": 933911,
	"./index/agroServices/faq.webp": 343063,
	"./index/agroServices/fieldEvaluationReport.png": 760078,
	"./index/agroServices/fieldEvaluationReport.webp": 313535,
	"./index/agroServices/price-analytics.png": 352435,
	"./index/agroServices/price-analytics.webp": 983300,
	"./index/agroServices/seedingRateCalc.png": 163633,
	"./index/agroServices/seedingRateCalc.webp": 915473,
	"./index/agroServices/soil_landscape_survey.png": 848593,
	"./index/agroServices/soil_landscape_survey.webp": 609979,
	"./index/agroServices/youDo.png": 689252,
	"./index/agroServices/youDo.webp": 450667,
	"./index/authBanner.png": 494578,
	"./index/authBanner.webp": 60742,
	"./index/financingBanner.png": 117697,
	"./index/financingBanner.webp": 606512,
	"./index/financingBannerMobile.png": 43809,
	"./index/financingBannerMobile.webp": 33174,
	"./index/financingBannerTablet.png": 141313,
	"./index/financingBannerTablet.webp": 172637,
	"./index/ifa/becomePartner1-full.png": 898305,
	"./index/ifa/becomePartner1-mob.png": 123479,
	"./index/ifa/becomePartner2-full.png": 959168,
	"./index/ifa/becomePartner2-mob.png": 640881,
	"./index/ifa/financingForm-bg-mobile.png": 828789,
	"./index/ifa/financingForm-bg.png": 388686,
	"./index/ifa/ifaBanner-full.jpg": 183026,
	"./index/ifa/ifaBanner-mob.jpg": 621449,
	"./index/ifa/joinUs-bg-main.jpg": 183603,
	"./index/ifa/joinUs-bg1.png": 293774,
	"./index/ifa/joinUs-bg2.png": 248321,
	"./index/ifa/registration-bg.png": 657684,
	"./index/invitation.png": 424538,
	"./index/invitation.webp": 511857,
	"./index/invitationTablet.png": 965979,
	"./index/invitationTablet.webp": 111323,
	"./index/outputs/barley.jpg": 737619,
	"./index/outputs/chickpeas.jpg": 582115,
	"./index/outputs/corn.jpg": 55365,
	"./index/outputs/cultureSale-bg.svg": 444953,
	"./index/outputs/lentils.jpg": 993929,
	"./index/outputs/mustard.jpg": 903956,
	"./index/outputs/oilseedFlax.jpg": 945027,
	"./index/outputs/oilseedSunflower.jpg": 386342,
	"./index/outputs/outputsSaleRequestForm-bg.svg": 478983,
	"./index/outputs/peas.jpg": 969431,
	"./index/outputs/rapeseedPlant.jpg": 551345,
	"./index/outputs/saleRequestForm/saleRequestFormFull-bg.svg": 175866,
	"./index/outputs/soybean.jpg": 796170,
	"./index/outputs/soybeanExtruded.jpg": 292329,
	"./index/outputs/soybeanMeal.jpg": 757959,
	"./index/outputs/soybeanRawOil.jpg": 116843,
	"./index/outputs/sunflowerCake.jpg": 360580,
	"./index/outputs/sunflowerConfectionery.jpg": 968566,
	"./index/outputs/sunflowerMeal.jpg": 458764,
	"./index/outputs/sunflowerOil.jpg": 853899,
	"./index/outputs/wheat.jpg": 608308,
	"./index/outputs/wheatDurum.jpg": 583052,
	"./index/partner-harvest-purchase.png": 382258,
	"./index/partner-harvest-purchase.webp": 169488,
	"./index/partner-harvest-sale.png": 494749,
	"./index/partner-harvest-sale.webp": 497396,
	"./index/partner.png": 428971,
	"./index/partner.webp": 798649,
	"./index/partners/agrocopoc.png": 986686,
	"./index/partners/agrocopoc.webp": 85764,
	"./index/partners/ahp.png": 232096,
	"./index/partners/ahp.webp": 43177,
	"./index/partners/alfa-bank.png": 610172,
	"./index/partners/alfa-bank.webp": 471446,
	"./index/partners/alfa-leasing-short.png": 26104,
	"./index/partners/alfa-leasing-short.webp": 261049,
	"./index/partners/alfa-leasing.png": 946433,
	"./index/partners/alfa-leasing.webp": 429229,
	"./index/partners/argoveles.png": 405317,
	"./index/partners/argoveles.webp": 84151,
	"./index/partners/balt_leasing.png": 879359,
	"./index/partners/balt_leasing.webp": 418495,
	"./index/partners/baltiyskiy-leasing-short.png": 620163,
	"./index/partners/baltiyskiy-leasing-short.webp": 452808,
	"./index/partners/baltiyskiy-leasing.png": 895019,
	"./index/partners/baltiyskiy-leasing.webp": 716834,
	"./index/partners/biotence.png": 531748,
	"./index/partners/biotence.webp": 632051,
	"./index/partners/center-invest.png": 486635,
	"./index/partners/center-invest.webp": 949426,
	"./index/partners/demetra.png": 992899,
	"./index/partners/demetra.webp": 219187,
	"./index/partners/efis-zsn.png": 991594,
	"./index/partners/efis-zsn.webp": 907597,
	"./index/partners/fes-agro.png": 117973,
	"./index/partners/fes-agro.webp": 774171,
	"./index/partners/fleet-finance-leasing-short.png": 993192,
	"./index/partners/fleet-finance-leasing-short.webp": 255146,
	"./index/partners/fleet-finance-leasing.png": 286407,
	"./index/partners/fleet-finance-leasing.webp": 551625,
	"./index/partners/fosagro.png": 505915,
	"./index/partners/fosagro.webp": 362316,
	"./index/partners/innagro.png": 926257,
	"./index/partners/innagro.webp": 86366,
	"./index/partners/interleasing-leasing-short.png": 411089,
	"./index/partners/interleasing-leasing-short.webp": 316801,
	"./index/partners/interleasing-leasing.png": 359487,
	"./index/partners/interleasing-leasing.webp": 199819,
	"./index/partners/interleasing-short.png": 422654,
	"./index/partners/interleasing-short.webp": 238835,
	"./index/partners/kas.png": 886371,
	"./index/partners/kas.webp": 985853,
	"./index/partners/ksm.png": 838075,
	"./index/partners/ksm.webp": 109083,
	"./index/partners/mirogroup.png": 609218,
	"./index/partners/mirogroup.webp": 28115,
	"./index/partners/pole_rf.png": 461316,
	"./index/partners/pole_rf.webp": 280326,
	"./index/partners/pro-agro.png": 853928,
	"./index/partners/pro-agro.webp": 701681,
	"./index/partners/rosagro-leasing-short.png": 995075,
	"./index/partners/rosagro-leasing-short.webp": 969027,
	"./index/partners/rosagro-leasing.png": 684623,
	"./index/partners/rosagro-leasing.webp": 940170,
	"./index/partners/sativa.png": 628373,
	"./index/partners/sativa.webp": 896010,
	"./index/partners/sber-business.png": 849351,
	"./index/partners/sber-business.webp": 658523,
	"./index/partners/sber-leasing-short.png": 116765,
	"./index/partners/sber-leasing-short.webp": 288736,
	"./index/partners/sber-leasing.png": 403898,
	"./index/partners/sber-leasing.webp": 141694,
	"./index/partners/sber-logo.png": 61180,
	"./index/partners/sber-logo.webp": 614976,
	"./index/partners/southern-house.png": 544957,
	"./index/partners/southern-house.webp": 310920,
	"./index/partners/stone-xxi-leasing-short.png": 977272,
	"./index/partners/stone-xxi-leasing-short.webp": 307350,
	"./index/partners/stone-xxi-leasing.png": 108429,
	"./index/partners/stone-xxi-leasing.webp": 304563,
	"./index/partners/tinkoff.png": 980344,
	"./index/partners/tinkoff.webp": 908065,
	"./index/partners/vtb-group.png": 397997,
	"./index/partners/vtb-group.webp": 920637,
	"./index/partners/vtb-leasing-short.png": 908652,
	"./index/partners/vtb-leasing-short.webp": 432428,
	"./index/partners/vtb-leasing.png": 526791,
	"./index/partners/vtb-leasing.webp": 693050,
	"./index/partners/vtb-short.png": 994458,
	"./index/partners/vtb-short.webp": 733023,
	"./index/partners/vtb.png": 76642,
	"./index/partners/vtb.webp": 199821,
	"./index/partners/youDo.png": 83611,
	"./index/partners/youDo.webp": 766961,
	"./index/registration.png": 169179,
	"./index/registration.webp": 808929,
	"./index/registrationTablet.png": 753535,
	"./index/registrationTablet.webp": 60375,
	"./index/telegramBanner/background-mob.png": 989140,
	"./index/telegramBanner/background-web.png": 939103,
	"./index/telegramBanner/tg-icon-mob.png": 208466,
	"./index/telegramBanner/tg-icon-web.png": 214434,
	"./installmentCalculator/landingResult.svg": 986535,
	"./installmentsModal/paymentMethod.png": 172110,
	"./installmentsModal/paymentMethod.webp": 412219,
	"./journal/article/banners/agriculturalProducts.svg": 12010,
	"./journal/article/banners/agrotechnics.svg": 690109,
	"./journal/article/banners/fertilizers.svg": 56851,
	"./journal/article/banners/financing.svg": 448170,
	"./journal/article/banners/fuel.svg": 946793,
	"./journal/article/banners/harvestSale.svg": 774972,
	"./journal/article/banners/remedies.svg": 129012,
	"./journal/article/banners/seeds.svg": 758075,
	"./journal/article/banners/tiresAndWheels.svg": 248392,
	"./journal/article/banners/usedAgrotechnics.svg": 557065,
	"./journal/article/telegram-large.svg": 200747,
	"./journal/publicationEditor/rutube.svg": 923605,
	"./journal/publicationEditor/yandex.svg": 233762,
	"./journal/publicationEditor/youtube.svg": 57468,
	"./leasingEscort/icons.png": 144208,
	"./leasingEscort/icons.webp": 46738,
	"./leasingSuccessModal/analyze.png": 232510,
	"./leasingSuccessModal/analyze.webp": 641007,
	"./leasingSuccessModal/grain.png": 209381,
	"./leasingSuccessModal/grain.webp": 855477,
	"./leasingSuccessModal/machine.png": 983125,
	"./leasingSuccessModal/machine.webp": 371607,
	"./leasingSuccessModal/paper.png": 378614,
	"./leasingSuccessModal/paper.webp": 361967,
	"./loanProducts/advanceFunding.png": 853191,
	"./loanProducts/advanceFunding.webp": 578621,
	"./loanProducts/bnplAgrointegrator.png": 494376,
	"./loanProducts/bnplAgrointegrator.webp": 464362,
	"./loanProducts/bnplMandarin.png": 872817,
	"./loanProducts/bnplMandarin.webp": 784953,
	"./loanProducts/brand/agrointegrator.png": 731713,
	"./loanProducts/brand/agrointegrator.webp": 816376,
	"./loanProducts/brand/alfa.png": 505952,
	"./loanProducts/brand/alfa.webp": 923103,
	"./loanProducts/brand/alfaMobile.png": 455700,
	"./loanProducts/brand/alfaMobile.webp": 525191,
	"./loanProducts/brand/centerInvest.png": 701432,
	"./loanProducts/brand/centerInvest.webp": 967675,
	"./loanProducts/brand/centerInvestMobile.png": 294717,
	"./loanProducts/brand/centerInvestMobile.webp": 28643,
	"./loanProducts/brand/demetra.png": 933616,
	"./loanProducts/brand/demetra.webp": 22871,
	"./loanProducts/brand/demetraMobile.png": 766750,
	"./loanProducts/brand/demetraMobile.webp": 209384,
	"./loanProducts/brand/fleetFinanceLeasing.png": 560108,
	"./loanProducts/brand/fleetFinanceLeasing.webp": 967178,
	"./loanProducts/brand/fleetFinanceLeasingMobile.png": 927522,
	"./loanProducts/brand/fleetFinanceLeasingMobile.webp": 683407,
	"./loanProducts/brand/interleasing.png": 579533,
	"./loanProducts/brand/interleasing.webp": 779978,
	"./loanProducts/brand/interleasingMobile.png": 120566,
	"./loanProducts/brand/interleasingMobile.webp": 938410,
	"./loanProducts/brand/mandarin.png": 693614,
	"./loanProducts/brand/mandarin.webp": 143429,
	"./loanProducts/brand/mandarinMobile.png": 826285,
	"./loanProducts/brand/mandarinMobile.webp": 827697,
	"./loanProducts/brand/poleFinance.png": 851963,
	"./loanProducts/brand/poleFinance.webp": 704459,
	"./loanProducts/brand/poleFinanceMobile.png": 985863,
	"./loanProducts/brand/poleFinanceMobile.webp": 341075,
	"./loanProducts/brand/poleRf.png": 297449,
	"./loanProducts/brand/poleRf.webp": 917940,
	"./loanProducts/brand/poleRfMobile.png": 449266,
	"./loanProducts/brand/poleRfMobile.webp": 904601,
	"./loanProducts/brand/rosagroleasing.png": 611460,
	"./loanProducts/brand/rosagroleasing.webp": 685936,
	"./loanProducts/brand/rosagroleasingMobile.png": 404653,
	"./loanProducts/brand/rosagroleasingMobile.webp": 712101,
	"./loanProducts/brand/sberBusiness.png": 525153,
	"./loanProducts/brand/sberBusiness.webp": 545239,
	"./loanProducts/brand/sberBusinessMobile.png": 368034,
	"./loanProducts/brand/sberBusinessMobile.webp": 790140,
	"./loanProducts/centerInvestLoan.png": 332427,
	"./loanProducts/centerInvestLoan.webp": 389341,
	"./loanProducts/expressMfo.png": 684331,
	"./loanProducts/expressMfo.webp": 688974,
	"./loanProducts/lombardLoanAlfaBank.png": 644407,
	"./loanProducts/lombardLoanAlfaBank.webp": 72199,
	"./loanProducts/sberInvestmentLoan.png": 852988,
	"./loanProducts/sberInvestmentLoan.webp": 325017,
	"./loanProducts/sberOborotkaLoan.png": 964166,
	"./loanProducts/sberOborotkaLoan.webp": 762705,
	"./loanProducts/sberpay.png": 368642,
	"./loanProducts/sberpay.webp": 94866,
	"./logos/agrointegrator.svg": 364412,
	"./logos/argonoutWhite.png": 980409,
	"./logos/argonoutWhite.webp": 370602,
	"./logos/demetraSquare.png": 517505,
	"./logos/demetraSquare.webp": 557793,
	"./logos/demetraTrading.png": 858458,
	"./logos/demetraWhite.png": 899859,
	"./logos/demetraWhite.webp": 404320,
	"./logos/designAuthor.svg": 514568,
	"./logos/efisZsn.png": 962122,
	"./logos/efisZsn.webp": 219239,
	"./logos/exactFarmingWhite.png": 114370,
	"./logos/exactFarmingWhite.webp": 18720,
	"./logos/mirogroupWhite.png": 288696,
	"./logos/mirogroupWhite.webp": 872784,
	"./logos/moneykapital.svg": 654502,
	"./logos/phosagro.png": 557070,
	"./logos/phosagro.webp": 319611,
	"./logos/phosagroWhite.png": 966135,
	"./logos/phosagroWhite.webp": 515096,
	"./logos/polerf.svg": 614889,
	"./logos/sber.svg": 327417,
	"./logos/sberBusiness.svg": 819966,
	"./logos/sberBusinessInline.svg": 528129,
	"./logos/sberIcon.svg": 209800,
	"./logos/sberSmallGradient.svg": 85601,
	"./logos/syngenta.png": 998832,
	"./logos/syngenta.webp": 522638,
	"./logos/vtbWhite.png": 565579,
	"./logos/vtbWhite.webp": 692160,
	"./logos/youDo.png": 150328,
	"./logos/youDo.svg": 896465,
	"./logos/youDo.webp": 437087,
	"./loyalty/coins.png": 776170,
	"./loyalty/coins.webp": 865202,
	"./loyalty/header_bg.svg": 309016,
	"./loyalty/loyalty_card_avatar.svg": 955042,
	"./loyalty/profile_header_bg.svg": 685460,
	"./machineMarks/audi.png": 916653,
	"./machineMarks/audi.webp": 807745,
	"./machineMarks/bmw.png": 42559,
	"./machineMarks/bmw.webp": 79365,
	"./machineMarks/hyundai.png": 74777,
	"./machineMarks/hyundai.webp": 185468,
	"./machineMarks/jeep.png": 851621,
	"./machineMarks/jeep.webp": 704145,
	"./machineMarks/kamaz.png": 549885,
	"./machineMarks/kamaz.webp": 730605,
	"./machineMarks/lada.png": 246952,
	"./machineMarks/lada.webp": 6118,
	"./machineMarks/landRover.png": 64599,
	"./machineMarks/landRover.webp": 833714,
	"./machineMarks/mercedes.png": 665800,
	"./machineMarks/mercedes.webp": 126147,
	"./machineMarks/nissan.png": 596833,
	"./machineMarks/nissan.webp": 687450,
	"./machineMarks/renault.png": 533516,
	"./machineMarks/renault.webp": 337345,
	"./machineMarks/toyota.png": 421319,
	"./machineMarks/toyota.webp": 159311,
	"./machineMarks/uaz.png": 669852,
	"./machineMarks/uaz.webp": 459374,
	"./machineMarks/volkswagen.png": 274259,
	"./machineMarks/volkswagen.webp": 313752,
	"./miniConsultingForm/bg.svg": 403751,
	"./offerDetails/warning.svg": 401326,
	"./offerGoodsRequest/goods.png": 243457,
	"./offerGoodsRequest/goods_2x.png": 59661,
	"./offerGoodsRequest/goods_3x.png": 162229,
	"./offerGoodsRequest/goods_3x.webp": 417997,
	"./offerRequest/error.svg": 899614,
	"./offerRequest/success.svg": 155371,
	"./offerRequest/trophy.png": 139316,
	"./offerRequest/warning.svg": 346424,
	"./offerRequests/cultures.png": 672032,
	"./offerRequests/cultures_2x.png": 552151,
	"./offerRequests/cultures_3x.png": 506954,
	"./ogimage.jpg": 35111,
	"./paymentVariants/agro.svg": 249791,
	"./paymentVariants/mandarin.svg": 7987,
	"./paymentVariants/money-capital.svg": 453310,
	"./paymentVariants/pole-credit.svg": 392632,
	"./paymentVariants/sber.svg": 146304,
	"./placeholder.png": 795256,
	"./producers/phosagro-logo.svg": 368507,
	"./product/placeholder.svg": 611696,
	"./profile-photo.png": 883096,
	"./promo/syngenta/syngenta-desktop.png": 652126,
	"./promo/syngenta/syngenta-desktop.webp": 830055,
	"./promo/syngenta/syngenta-mobile.png": 470390,
	"./promo/syngenta/syngenta-mobile.webp": 550077,
	"./promo/syngenta/syngenta-tablet.png": 163632,
	"./promo/syngenta/syngenta-tablet.webp": 551401,
	"./promo/vezdehodPromoLanding.png": 881541,
	"./promo/vezdehodPromoLanding.webp": 709356,
	"./promo/whiteCircle.png": 293889,
	"./promo/whiteCircle.webp": 900440,
	"./publicationBanners/agriculturalProducts.svg": 312148,
	"./publicationBanners/agrotechnics.svg": 793827,
	"./publicationBanners/fertilizers.svg": 349194,
	"./publicationBanners/financing.svg": 780518,
	"./publicationBanners/fuel.svg": 565909,
	"./publicationBanners/harvestSale.svg": 254242,
	"./publicationBanners/remedies.svg": 837102,
	"./publicationBanners/seeds.svg": 480592,
	"./publicationBanners/tiresAndWheels.svg": 758474,
	"./publicationBanners/usedAgrotechnics.svg": 210004,
	"./publicationFinancingWidget/advance-funding.png": 256463,
	"./publicationFinancingWidget/agent.png": 108355,
	"./publicationFinancingWidget/express-mfo.png": 458871,
	"./team/belov.png": 6948,
	"./team/belov.webp": 469647,
	"./team/berezovskaya.png": 118891,
	"./team/berezovskaya.webp": 277672,
	"./team/boluchevskij.png": 453939,
	"./team/boluchevskij.webp": 839646,
	"./team/daudova.png": 473375,
	"./team/daudova.webp": 463706,
	"./team/efimova.png": 476210,
	"./team/efimova.webp": 485843,
	"./team/frolova.png": 811643,
	"./team/frolova.webp": 585509,
	"./team/gorn.png": 155002,
	"./team/gorn.webp": 271929,
	"./team/kolodkina.png": 96649,
	"./team/kolodkina.webp": 416519,
	"./team/podobedov.png": 741728,
	"./team/podobedov.webp": 377418,
	"./team/zajchuk.png": 298550,
	"./team/zajchuk.webp": 976240,
	"./tender/filledArrowDown.svg": 217798,
	"./tender/filledArrowUp.svg": 30090,
	"./tender/filledArrows.svg": 829194,
	"./test/articles/1.png": 982774,
	"./test/articles/3.png": 292843,
	"./test/articles/4.png": 231363,
	"./test/articles/5.png": 838975,
	"./test/articles/6.png": 5322,
	"./test/articles/7.png": 186815,
	"./test/articles/8.png": 540118,
	"./test/articles/9.png": 691010,
	"./test/cows.jpg": 950014,
	"./trophy.png": 748969,
	"./upload-photo.png": 883324,
	"./vehicles/flatbed_coupler.png": 657577,
	"./vehicles/flatbed_coupler.webp": 633445,
	"./vehicles/kamaz.png": 37426,
	"./vehicles/kamaz.webp": 10903,
	"./vehicles/semi_trailer.png": 579984,
	"./vehicles/semi_trailer.webp": 849850,
	"./vehicles/tonar.png": 666417,
	"./vehicles/tonar.webp": 326146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552116;